export default __webpack_public_path__ + "static/media/icon-mail-solid.f9fadfcb.svg";